import { Table, Pagination } from "antd";
import { useState } from "react";

function AllActivityTable() {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const generateRandomData = (id) => ({
    date: "Oct 05, 2024 12:34 PM",
    action: "Login to the system",
    details: "Desktop computer",
    ip: "192.168.0.1",
  });

  const repeatedData = Array.from({ length: 50 }, (_, index) =>
    generateRandomData(index + 1)
  );

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      sorter: (a, b) => a.action.localeCompare(b.action),
    },
    {
      title: "Details",
      dataIndex: "details",
      key: "details",
      sorter: (a, b) => a.details.localeCompare(b.details),
    },
    {
      title: "IP Address",
      dataIndex: "ip",
      key: "ip",
      sorter: (a, b) => a.ip.localeCompare(b.ip),
    },
  ];

  return (
    <div className="all-activity-table-container">
      <Table
        columns={columns}
        dataSource={repeatedData.slice((currentPage - 1) * pageSize, currentPage * pageSize)}
        pagination={false}
        scroll={{ x: 1000, y: 500 }}
        rowKey={(record) => record.id}
        onRow={(record) => ({
          onClick: () => {
            console.log(record);
          },
        })}
      />
      <div className="pagination">
        <Pagination
          current={currentPage}
          total={repeatedData.length}
          pageSize={pageSize}
          showSizeChanger
          onChange={handlePaginationChange}
        />
      </div>
    </div>
  );
}

export default AllActivityTable;
